// Shared story player: a first tap unlocks it on phones, later stories just swap its source
const SILENCE = "data:audio/wav;base64,UklGRuwAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YcgAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgA==";
let el = null;
let unlocked = false;

export const storyAudio = () => {
  if (!el) el = new Audio();
  return el;
};

export const playStory = (a) => a.play().then(() => { unlocked = true; });

// Call synchronously inside a tap handler, before any await
export const primeStoryAudio = () => {
  const a = storyAudio();
  if (unlocked || !a.paused) return;
  a.src = SILENCE;
  playStory(a).catch(() => {});
};
